var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.teacher_name)?_c('span',[_vm._v(_vm._s(_vm.item.teacher_name))]):_vm._e(),(_vm.item.search_name)?_c('span',[_vm._v(_vm._s(_vm.item.search_name))]):_c('span',[_vm._v(_vm._s(_vm.item.no_result))])])
}
var staticRenderFns = []

export { render, staticRenderFns }